import type { RuntimeAnswer } from '../../types/runtime';

interface Props {
  answer: RuntimeAnswer;
}

export function DebugStateCard({ answer }: Props) {
  return (
    <article className="rounded-lg border border-slate-200 bg-white p-4 text-sm text-slate-700">
      <div className="mb-2 flex items-center gap-2">
        <span className="rounded bg-slate-100 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-slate-600">
          State preview
        </span>
        <span className="font-mono text-xs text-slate-500">{answer.phase}</span>
      </div>
      <p className="whitespace-pre-line leading-relaxed">{answer.content}</p>
    </article>
  );
}
